import { createStyles, Link, makeStyles, Theme } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import * as React from "react";
import { useHistory } from "react-router";
import { PALETTE_DARK_BLUE, PALETTE_LIGHT_BLUE } from "../../Styles/Constants";

interface RouteLinkProps {
    route: string;
    variant?: Variant;
    marginTop?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        link: {
            color: theme.palette.type == "dark" ? PALETTE_LIGHT_BLUE : PALETTE_DARK_BLUE
        }
    })
);

export const RouteLink: React.FunctionComponent<RouteLinkProps> = React.memo(props => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <Link component="button" variant={props.variant ?? "subtitle1"} style={{ marginTop: props.marginTop ?? "-0.1rem" }} className={classes.link} onClick={() => history.push(props.route)}>{props.children}</Link>
    );
});

RouteLink.displayName = "RouteLink";